import { chooseDBTranslation } from 'utils/translations'
import { Paragraph, TextRun } from 'docx'
import { CVData } from 'types/printInterfaces'
import { itemParagraphSpacing } from './itemHeading'
import { fontSize } from './pageLayout'
import { i18n as i18nType } from 'i18next'

/**
 * Generates an array of paragraphs containing URLs and their descriptions.
 *
 * @param {object} i18n - The internationalization object.
 * @param {CVData} data - The CV data object.
 * @returns {Paragraph[]} An array of paragraphs containing URLs and their descriptions.
 * @notExported
 */
const url = (i18n: i18nType, data: CVData): Paragraph[] => {
  const urls: Paragraph[] = []

  for (let i = 0; i < data.urls.length; i++) {
    const url = data.urls[i]

    const description = url ? chooseDBTranslation(i18n, url).description : ''

    urls.push(
      new Paragraph({
        keepLines: true,
        style: 'CaleoNormal',
        spacing: itemParagraphSpacing,
        children: [
          new TextRun({
            text: url && url.url,
          }),
          ...(description ? [new TextRun({ text: description, size: fontSize.small, break: 1 })] : []),
        ],
      })
    )
  }

  return urls
}

export default url
